export type GoalPermissions = {
	userCanEditValue: boolean;
	userCanShareGoal: boolean;
	userCanDeleteShare: boolean;
	userCanCopyGoal: boolean;
	userCanEditStatus: boolean;
	userCanDeleteGoal: boolean;
	userCanEditDetails: boolean;
	userCanReorderChecklists: boolean;
	userCanAddChecklistItem: boolean;
	userCanEditChecklistItemStatus: boolean;
	userCanEditHistoryAsOfDate: boolean;
	userCanAddGoalsComments: boolean;
	userCanDeleteComment: boolean;
	userCanDeleteValueUpdate: boolean;
};

/*
    This function parses the permissions array from the RBAC endpoint and returns a GoalPermissions object

*/
export const parseGoalPermissionsForUser = (permissions: string[] = []): GoalPermissions => {
	return {
		userCanShareGoal: permissions?.includes("goals:addShareWith"),
		userCanDeleteShare: permissions?.includes("goals:deleteShareWith"),
		userCanEditValue: permissions?.includes("goals:editValue"),
		userCanCopyGoal: permissions?.includes("goals:copyGoal"),
		userCanEditStatus: permissions?.includes("goals:editStatus"),
		userCanDeleteGoal: permissions?.includes("goals:deleteGoal"),
		userCanEditDetails: permissions?.includes("goals:editDetails"),
		userCanReorderChecklists: permissions?.includes("goals:reorderChecklist"),
		userCanAddChecklistItem: permissions?.includes("goals:addChecklistItem"),
		userCanEditChecklistItemStatus: permissions?.includes("goals:editChecklistItemStatus"),
		userCanEditHistoryAsOfDate: permissions?.includes("goals:editHistoryAsOfDate"),
		userCanAddGoalsComments: permissions?.includes("goals:addComment"),
		userCanDeleteComment: permissions?.includes("goals:deleteComment"),
		userCanDeleteValueUpdate: permissions?.includes("goals:deleteValueUpdate"),
	};
};
